export default {
  // 节点类型描述
  expandNode: "这是扩展点",

  // 标签相关
  tags: "标签",

  // 平台相关
  platform: "平台",
  analysisId: "分析ID",
  userId: "用户ID",
  deviceId: "设备ID",

  // 钱包平台名称
  bitpieWallet: "比特派钱包",
  imToken: "imToken",

  // 字段标签
  exchangeName: "交易所名称",
  bankCardNumber: "银行卡号",
  username: "用户名",
  userIdField: "用户id",
  phoneNumber: "手机号",
  surveyUser: "已调证用户",

  // 注释中的统计信息（保留用于将来可能的显示）
  inflowCount: "流入计数",
  outflowCount: "流出计数",
  usdtInflowAvgQuantity: "USDT 转入平均数量",
  usdtInflowOpponentCount: "USDT 转入对手数",
  usdtInflowTotalQuantity: "USDT 转入总数量",
  usdtOutflowAvgQuantity: "USDT 转出平均数量",
  usdtOutflowOpponentCount: "USDT 转出对手数",
  usdtOutflowTotalQuantity: "USDT 转出总数量",
};
